module.exports = __webpack_public_path__ + "img/4.fd5f4361.png";